import { render, staticRenderFns } from "./click-to-edit-long.vue?vue&type=template&id=245528ef"
import script from "./click-to-edit-long.vue?vue&type=script&lang=js"
export * from "./click-to-edit-long.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports